import { CaretDown, File, FolderSimple, ListBullets, MagnifyingGlass, Plus, SquaresFour } from 'phosphor-react';

function StorageToolbar({
  queryText,
  setQueryText,
  typeFilter,
  setTypeFilter,
  sortBy,
  setSortBy,
  viewMode,
  setViewMode,
  currentFolderId,
  setCurrentFolderId,
  rootFolderId,
  isAddMenuOpen,
  setIsAddMenuOpen,
  addMenuRef,
  fileInputRef,
  onUploadClick,
  onUploadInputChange,
  onCreateFolder
}) {
  return (
    <>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-3">
            <img src="/apps/storage/logo/logo.png" alt="Storage logo" className="h-10 w-10 rounded-xl object-cover" />
            <h1 className="text-xl font-bold">Storage</h1>
          </div>
          <p className="mt-1 text-sm text-slate-600">Upload files, organize folders, and browse your items in one place.</p>
        </div>

        <div className="relative" ref={addMenuRef}>
          <button
            type="button"
            onClick={() => setIsAddMenuOpen((prev) => !prev)}
            className="inline-flex items-center gap-2 rounded-xl bg-brand-500 px-4 py-3 text-sm font-semibold text-white transition hover:bg-brand-700"
          >
            <Plus size={16} weight="bold" />
            Add
            <CaretDown size={14} weight="bold" />
          </button>
          {isAddMenuOpen && (
            <div className="absolute right-0 z-20 mt-2 w-44 rounded-xl border border-slate-200 bg-white p-1 shadow-lg">
              <button
                type="button"
                className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 transition hover:bg-slate-100"
                onClick={() => {
                  setIsAddMenuOpen(false);
                  onUploadClick();
                }}
              >
                <File size={15} weight="bold" />
                Upload files
              </button>
              <button
                type="button"
                className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 transition hover:bg-slate-100"
                onClick={() => {
                  setIsAddMenuOpen(false);
                  onCreateFolder();
                }}
              >
                <FolderSimple size={15} weight="bold" />
                New folder
              </button>
            </div>
          )}
          <input ref={fileInputRef} type="file" multiple className="hidden" onChange={onUploadInputChange} />
        </div>
      </div>

      {currentFolderId && (
        <div className="mt-4">
          <button
            type="button"
            onClick={() => setCurrentFolderId(rootFolderId)}
            className="text-sm font-semibold text-brand-700 underline decoration-brand-300 underline-offset-4"
          >
            Back to My files
          </button>
        </div>
      )}

      <div className="mt-4 grid gap-3 lg:grid-cols-[minmax(220px,1fr)_160px_170px_auto]">
        <div className="relative">
          <MagnifyingGlass size={15} weight="bold" className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="text"
            value={queryText}
            onChange={(event) => setQueryText(event.target.value)}
            placeholder="Search in this folder"
            className="w-full rounded-xl border border-slate-200 py-2 pl-9 pr-3 text-sm outline-none transition focus:ring focus:ring-brand-200"
          />
        </div>

        <select
          value={typeFilter}
          onChange={(event) => setTypeFilter(event.target.value)}
          className="rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none transition focus:ring focus:ring-brand-200"
        >
          <option value="all">All items</option>
          <option value="folder">Folders</option>
          <option value="file">Files</option>
        </select>

        <select
          value={sortBy}
          onChange={(event) => setSortBy(event.target.value)}
          className="rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none transition focus:ring focus:ring-brand-200"
        >
          <option value="updated-desc">Newest</option>
          <option value="updated-asc">Oldest</option>
          <option value="name-asc">Name A-Z</option>
          <option value="name-desc">Name Z-A</option>
          <option value="size-desc">Size large-small</option>
          <option value="size-asc">Size small-large</option>
        </select>

        <div className="inline-flex overflow-hidden rounded-xl border border-slate-200">
          <button
            type="button"
            onClick={() => setViewMode('grid')}
            className={`inline-flex items-center gap-1 px-3 py-2 text-sm transition ${viewMode === 'grid' ? 'bg-slate-900 text-white' : 'bg-white text-slate-700'}`}
          >
            <SquaresFour size={14} weight="bold" />
            Grid
          </button>
          <button
            type="button"
            onClick={() => setViewMode('list')}
            className={`inline-flex items-center gap-1 px-3 py-2 text-sm transition ${viewMode === 'list' ? 'bg-slate-900 text-white' : 'bg-white text-slate-700'}`}
          >
            <ListBullets size={14} weight="bold" />
            List
          </button>
        </div>
      </div>
    </>
  );
}

export default StorageToolbar;
